import React from 'react';
import * as Styled from './Input.styled';
import { useTooltipContext } from '@Utils/shared/components/RaidIdTooltip/tooltipContext';
import { useGetElementCoords } from '@Utils/shared/components/RaidIdTooltip/hooks/useGetElementCoords';
import TooltipSwitchButton from '../Tooltip/TooltipSwitchButton';
import { DownloadLogoFormInput } from '../Steps/hooks/useInputData';

interface OwnProps {
  input: DownloadLogoFormInput;
}

const X_OFFSETT_COEF = 2;
const INFO_ICON_POSITION = 35;

const Input: React.FC<OwnProps> = ({ input }) => {
  const inputWrapperRef = React.useRef<HTMLDivElement | null>(null);
  const inputWrapperCoords = useGetElementCoords(inputWrapperRef);
  const { size, setCoords } = useTooltipContext();

  React.useEffect(() => {
    const x = inputWrapperCoords.x + inputWrapperCoords.width - size.width / X_OFFSETT_COEF;
    const y = inputWrapperCoords.y - size.height - INFO_ICON_POSITION;
    setCoords({ x, y });
  }, [
    inputWrapperCoords.x,
    inputWrapperCoords.width,
    inputWrapperCoords.y,
    setCoords,
    size.height,
    size.width,
  ]);

  const handleUserIdOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    input.setUserId(e.currentTarget.value);
    input.clearError();
  };

  const hasError = React.useMemo(() => input.error !== '', [input.error]);

  return (
    <Styled.InputWrapper ref={inputWrapperRef} hasError={hasError}>
      <Styled.InputElement
        placeholder={input.placeholder}
        name={input.name}
        value={input.userId}
        onChange={handleUserIdOnChange}
      />
      <TooltipSwitchButton />
    </Styled.InputWrapper>
  );
};

export default Input;
